import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getImagePath } from '@/utils/paths';

const Hero = () => {
  const handleScrollTo = (id) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image with Parallax */}
      <motion.div
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: 'easeOut' }}
        className="absolute inset-0 z-0"
      >
        <img
          src={getImagePath('/images/accueil.webp')}
          alt="Cabinet MN Médecine Esthétique à Rouvroy, près de Lens et du Pas-de-Calais"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-white" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0, duration: 0.8 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-white mb-6 tracking-tight leading-tight">
            Médecine esthétique à Rouvroy
            <br />
            <span className="font-normal">près de Lens &amp; du Pas-de-Calais</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-12 max-w-2xl mx-auto font-light">
            Hydrafacial, lasers, injections — cabinet médical sur rendez-vous. Une histoire de famille,
            de science et d&apos;équilibre.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <motion.button
              onClick={() => handleScrollTo('#contact')}
              className="btn-primary flex items-center gap-2"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              data-testid="hero-cta-button"
            >
              Prendre rendez-vous
              <ArrowRight size={20} />
            </motion.button>
            <motion.button
              onClick={() => handleScrollTo('#services')}
              className="btn-secondary border-0 bg-white/10 backdrop-blur-sm text-white shadow-none hover:bg-white hover:text-[#1e3a5f]"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Découvrir nos soins
            </motion.button>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;